<template>
 <img :src="iconURL" height="30" width="30"/>
</template>

<script>
export default {
    name: 'Icon',
    props: {
        iconURL: {
            type: String
        }
    }
};
</script>
